import { TL, TLEvent } from "./turbolinks";
import { Fancybox } from "./fancybox";

/* Le script qui initialise le player enregistre les instances dans un tableau global. cf javascript/mejs-init.js */
declare global {
  interface Window {
    MediaElementPlayerInstances: MediaElementPlayerInstanceContainer;
  }
}

interface MediaElementPlayerInstanceContainer {
  [key: string]: JQuery<HTMLElement>;
}

export class Player {
  static element?: JQuery<HTMLElement>;

  static register() {
    /* Préparer les players audio */
    TL.bind("load", () => {
      PlayerWindow.replaceInlinePlayers();
      PlayerWindow.replacePlayerButtons();
      PlayerWindow.bindPlayerLinks();
      Player.adjustDocument();
    });

    /* Avant de remplacer le body, on transfère le player */
    TL.bind("before-render", (event: TLEvent) => {
      if (event.hasOwnProperty("data")) {
        $(event.data.newBody).append(Player.element ?? "");
      }
    });

    TL.bind("after-render", (_event: TLEvent) => {
      Player.element = $("#player");
    });
  }

  static start(id_doc: number) {
    $.get("spip.php?page=player&var_zajax=oui&id_document=" + id_doc, function (
      data
    ) {
      if (Player.element !== undefined) {
        Player.destroy();
      }

      window.addEventListener("mediaplayer:loaded", Player.adjustDocument, {
        once: true,
      });

      $("body").append(data);

      Player.element = $("#player");
      Player.element.find("#player_close").on("click", Player.destroy);

      window.addEventListener("resize", Player.adjustDocument);

      Fancybox.onActivate(Player.adjustFancybox);
    });
  }

  static destroy() {
    if (Player.element === undefined) {
      return;
    }

    const id = Player.element.find(".spip_documents").attr("id");

    if (typeof id === "string") {
      const key = ("#" + id).replace("media", "audio"),
        meInstances = window.MediaElementPlayerInstances;

      if (meInstances.hasOwnProperty(key)) {
        const meInstance = meInstances[key];
        meInstance.remove();
      }
    }

    Player.element.remove();
    delete Player.element;

    Player.adjustDocument();
    window.removeEventListener("resize", Player.adjustDocument);

    Fancybox.offActivate(Player.adjustFancybox);
  }

  static adjustDocument() {
    Player.adjustPlayer();
    Player.adjustBody();
    Player.adjustFancybox();
  }

  /* On donne une hauteur fixe au player, pour éviter du flickering sur mobile. */
  static adjustPlayer() {
    if (Player.element === undefined) {
      return;
    }

    Player.element.attr("style", null);

    const player_height = Player.element.height();

    if (typeof player_height === "number") {
      Player.element.css("height", player_height);
    }

    // Si l'image n'a pas encore été chargée, on recommence au prochain tick.
    const img = Player.element.find("img");
    if (img?.length && !img[0].complete) {
      window.requestAnimationFrame(Player.adjustPlayer);
    }
  }

  static adjustBody() {
    const player_height = Player.element?.height();

    if (player_height === undefined) {
      $("body").attr("style", null);
    } else if (typeof player_height === "number") {
      $("body").css("padding-bottom", player_height);
    }
  }

  static adjustFancybox() {
    const player_height = Player.element?.height(),
      $fancy_containers = $(".fancybox-inner, .fancybox-thumbs");

    if (player_height === undefined) {
      $fancy_containers.css("padding-bottom", 0);
    } else if (typeof player_height === "number") {
      $fancy_containers.css("padding-bottom", player_height);
    }
  }
}

class PlayerWindow {
  /* On retire les players inline, et on les remplace par des liens qui commandent
   * le player persistant. */
  static replaceInlinePlayers() {
    $(".contenu .spip_documents.audio").each(function (_i, doc) {
      const $doc = $(doc),
        doc_id = $doc.data("id_document"),
        doc_title = $doc.data("titre_document"),
        $logo = $doc.find(".logo");

      $doc.find(".mejs__container").remove();
      $doc.find("audio.mejs").remove();

      if ($logo.find("img").length === 0) {
        $logo.prepend(
          '<span style="width: 100px; height: 100px; display: inline-block;"></span>'
        );
      }

      $logo
        .prepend('<div class="cover"></div>')
        .wrap(
          '<a href="#" class="player-link" title="écouter « ' +
            doc_title +
            ' »" data-id_document="' +
            doc_id +
            '"></a>'
        );

      $doc.addClass("player-attached");
    });
  }

  static replacePlayerButtons() {
    $(".player_button").each((_i, button) => {
      const $button = $(button),
        doc_id = $button.data("id_document"),
        doc_title = $button.data("titre_document");

      $button.replaceWith(
        '<a href="#" class="player-link" title="écouter « ' +
          doc_title +
          ' »" data-id_document="' +
          doc_id +
          '"><div class="cover"></div></a>'
      );
    });
  }

  /* Les liens .player-link vont chercher le code du player et l'intègrent dans la page. */
  static bindPlayerLinks() {
    $(".player-link").each(function (_i, link) {
      $(link).on("click", function (event) {
        const $link = $(link),
          doc_id = $link.data("id_document");

        Player.start(doc_id);

        event.preventDefault();
        return false;
      });
    });
  }
}
